import React from "react";
import { useHistory } from "react-router-dom";

//UI
import { Skeleton, Row, Col, Form } from "antd";
import { Input } from "../Common/Input";
import { ButtonPrimary, ButtonLink } from "../Common/Button";
import { SearchOutlined, PlusOutlined } from "@ant-design/icons";
import {
  HomePageHeader,
  HeaderRightItem,
  HeaderLeftItemsWrapper,
  HeaderRightItemsWrapper,
} from "../Common/UIElements";
import CustomerDropdown from "./CustomerSelect/CustomerDropdown";

const PropertyContactUsersTopBar = (props) => {
  const history = useHistory();

  const {
    updateSearchMeta,
    customer,
    setCustomer,
    addPropertyUser,
    disableAddPropertyUser,
  } = props;

  return (
    <div className="corporate-contact-users-top-bar">
      <Skeleton loading={false} active>
        <HomePageHeader>
          <Col xxl={16} xl={16} lg={16} md={16} sm={24} xs={24}>
            <Form layout="vertical">
              <HeaderLeftItemsWrapper>
                <Col xxl={8} xl={8} lg={6} md={6} sm={24} xs={24}>
                  <Form.Item label="Customer Name (HMG)">
                    <CustomerDropdown
                      setCustomer={setCustomer}
                      customer={customer}
                    />
                  </Form.Item>
                </Col>
                <Col xxl={8} xl={8} lg={6} md={6} sm={24} xs={24}>
                  <Form.Item label=" ">
                    <Input
                      name="searchAll"
                      className="onboarding-toolbar-input"
                      prefix={<SearchOutlined />}
                      onChange={(e) => {
                        updateSearchMeta(e.target.value, "searchAll");
                      }}
                      placeholder="Search"
                      allowClear
                    />
                  </Form.Item>
                </Col>
              </HeaderLeftItemsWrapper>
            </Form>
          </Col>
          <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
            <HeaderRightItemsWrapper>
              <HeaderRightItem>
                <ButtonLink
                  onClick={addPropertyUser}
                  size="large"
                  icon={<PlusOutlined />}
                  disabled={disableAddPropertyUser}
                >
                  Add Property Contact User
                </ButtonLink>
              </HeaderRightItem>
              <HeaderRightItem>
                <ButtonPrimary
                  onClick={() => {
                    history.push("/onboarding/dashboard");
                  }}
                >
                  Back to Dashboard
                </ButtonPrimary>
              </HeaderRightItem>
            </HeaderRightItemsWrapper>
          </Col>
        </HomePageHeader>
      </Skeleton>
    </div>
  );
};

export default PropertyContactUsersTopBar;
